import React from 'react';
import { Text } from '../../text';
import clsx from 'clsx';
import { hashClass } from '../../../helpers';
import { useTrilogyContext } from '../../../context';
import { has } from '../../../services';
import { getBackgroundClassName } from '../../../objects';
/**
 * Box Header Component
 * @param className {string} Additionnal CSS Classes
 * @param children {React.ReactNode} Children
 * @param help {string} Box Header Help Sticker
 * @param centered {boolean} Center content box header
 * @param pulledLeft {boolean} Pulled-left content box header
 * @param pulledRight {boolean} Pulled-right content box header
 * @param color {TrilogyColor} Box Header backgroundColor
 * @param others
 */
const BoxHeader = ({ children, className, help, centered, pulledLeft, pulledRight, color, testId, ...others }) => {
    const { styled } = useTrilogyContext();
    const classes = hashClass(styled, clsx('box-header', className, centered && 'has-text-centered', pulledRight && 'has-text-right', pulledLeft && 'has-text-left', color && has(getBackgroundClassName(color))));
    return (React.createElement("header", { "data-testid": testId, className: classes, ...others },
        children && typeof children.valueOf() === 'string' ? React.createElement("p", null, children) : children,
        help && (React.createElement(Text, { testId: testId && `${testId}-help`, className: 'box-header-help sticker is-small is-success' }, String(children)))));
};
export default BoxHeader;
//# sourceMappingURL=BoxHeader.js.map